<template>
  <div class="product-category_table">
    <v-treeview
      ref="tree"
      :items="items"
      open-on-click
      :item-children="itemChildren"
      :open.sync="open"
      v-bind="$attrs"
    >
      <template v-slot:label="{ item }">
        <div
          :class="{ treeOdd: item.tIndex % 2 === 0 }"
          class="background_odd_class"
        >
          <span style="position: relative; z-index: 1">
            {{ item.name }}
            <v-list-item-subtitle
              v-if="item.type === productKey && item.productAttrs"
            >
              {{ item.productAttrs.join(" || ") }}
            </v-list-item-subtitle>
            <v-progress-circular
              v-if="item.loading"
              indeterminate
              width="2"
              size="12"
            ></v-progress-circular>
          </span>
        </div>
      </template>
      <template #prepend="{ open, item }">
        <div v-if="item[itemChildren]">
          <div
            :style="{ marginLeft: item.padding + 'px' }"
            :class="[
              'cus-tree-activator',
              {
                active: open,
                disabled:
                  item[itemChildren].length === 0 && !$attrs['load-children'],
              },
            ]"
          >
            <span class="cus-tree-activator-item"></span>
            <span class="cus-tree-activator-item"></span>
          </div>
        </div>
        <div v-else :style="{ marginLeft: item.padding + 10 + 'px' }"></div>
      </template>
      <template #append="{ item }">
        <slot v-if="!item.disabled" name="append" :item="item"> </slot>
      </template>
    </v-treeview>
  </div>
</template>

<script>
import { categoryKey, productKey } from "@/utils/constants";

export default {
  name: "CustomTreeView",
  props: {
    items: {
      type: Array,
      required: true,
    },
    itemChildren: {
      type: String,
      default: "children",
    },
  },
  data() {
    return {
      open: [],
      treeItems: [],
    };
  },
  computed: {
    productKey: () => productKey,
  },
  methods: {
    setTreeIndex(items, index = -1, padding = 0) {
      if (items)
        items.forEach((item) => {
          item.tIndex = ++index;
          item.padding = padding;
          if (item && item.type === categoryKey) {
            this.setTreeIndex(
              item[this.itemChildren],
              item.tIndex,
              padding + 24
            );
          } else {
            delete item[this.itemChildren];
          }
        });
    },
    updateAll() {
      const { tree } = this.$refs;
      tree.updateAll();
    },
    init() {
      this.setTreeIndex(this.items);
      this.treeItems = this.items;
    },
  },
};
</script>

<style scoped></style>
